import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import log from 'common/services/logging/loggers';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
/**
 * @ngdoc directive
 * @name controllers.BaseAuth
 *
 * @description
 * The base controller of the auth section.
 * It is the parent controller of login, forgot, reset, signup sections
 */
angular.module('controllers')
    .controller('BaseAuth', (
        $scope, $rootScope, Facebook, Google,
        Auth, AppleIDService, $window,
    ) => {

        $rootScope.State.finishedLoadingAnimation = true;
        $scope.browserName = $window.browserName.toLowerCase();

        const initialUrl = String(Session.getValue(SessionKeys.InitialUrl));

        if (initialUrl.indexOf('action=login_reactivate_license') > -1) {

            $scope.showReactivateLogin = true;
            Auth.gotoLogin();
            $scope.cancelReactivateLicense = () => {

                if (window.external && ('CloseHtml' in window.external)) {

                    window.external.CloseHtml('cancel reactivate license');

                }

            };

        }

        if (localStorage.getItem('theme') === 'dark') {

            $rootScope.State.theme = 'dark';

        } else {

            $rootScope.State.theme = 'light';

        }

        if (window.external && ('CloseHtml' in window.external)) {

            $rootScope.State.isFromSpotlightWebApp = 'spotlight';

        }

        Recaptcha.init();

        $scope.Recaptcha = Recaptcha;

        // facebook config
        $scope.fb = {
            feature: CWCONFIG.features.facebook,
            loaded: false,
        };

        // google plus config
        $scope.gplus = {
            feature: CWCONFIG.features.google,
            loaded: false,
        };

        // Apple ID config
        $scope.appleID = {
            feature: CWCONFIG.features.appleID,
            loaded: false,
            inProgress: false,
        };

        /**
         * @description
         * Facebook authenticate method.
         */
        $scope.fb.authenticate = (page) => {

            // initiate facebook service only when the user clicks on the button
            if ($scope.fb.loaded === false) {

                Facebook.init();

                Facebook.loaded().then(() => {

                    $scope.fb.loaded = true;
                    executeFacebookLogin(page);

                });

            } else {

                // if the scripts are loaded, execute only the login function
                executeFacebookLogin(page);

            }

        };

        function executeFacebookLogin(page) {

            Auth.loginType = 'Facebook'; // Login type for mixpanel event

            Mixpanel.send('ConnectWeb Facebook Click', {
                Page: `Auth ${page}`,
            });

            Facebook.login((response) => {

                if (response.authResponse) {

                    Auth.loginWithFacebook(response.authResponse, page);

                }

            }, {
                scope: 'email',
            });

        }

        /**
         * @description
         * Google authenticate method.
         */
        $scope.gplus.authenticate = (page) => {

            // initiate google service only when the user clicks on the button
            if ($scope.gplus.loaded === false) {

                Google.init();

                Google.loaded().then(() => {

                    $scope.gplus.loaded = true;
                    executeGoogleLogin(page);

                });

            } else {

                // if the scripts are loaded, execute only the login function
                executeGoogleLogin(page);

            }

        };

        function executeGoogleLogin(page) {

            Auth.loginType = 'Google Plus'; // Login type for mixpanel event

            Mixpanel.send('ConnectWeb Google Plus Click', {
                Page: `Auth ${page}`,
            });

            Google.login().then((response) => {

                Auth.loginWithGooglePlus(response, page);

            });

        }

        $scope.setCaptchaResponse = (response) => {

            Recaptcha.setCaptchaResponse(response);

        };

        // Apple ID Authentication
        $scope.appleID.authenticate = (page) => {

            Auth.loginType = 'Apple ID';

            Mixpanel.send('ConnectWeb Apple ID Click', {
                Page: `Auth ${page}`,
            });

            // initiate google service only when the user clicks on the button
            if ($scope.appleID.loaded === false) {

                AppleIDService.init().then(() => {

                    document.addEventListener('AppleIDSignInOnSuccess', (data) => {

                        Auth.loginWithAppleID(data.detail.authorization.code, page);

                    });

                    // Listen for authorization failures
                    document.addEventListener('AppleIDSignInOnFailure', (error) => {

                        log.debug({
                            type: `Apple Error - ${error.detail.error}`,
                            data: {},
                        });

                    });

                    $scope.appleID.loaded = true;
                    $window.AppleID.auth.signIn();

                }).catch(() => {

                    Alert.error('cw.notification.system.error');
                    $scope.appleID.inProgress = false;

                });

            } else {

                // if the scripts are loaded, execute only the login function
                $window.AppleID.auth.signIn();

            }

        };

    });



// WEBPACK FOOTER //
// ./scripts/common/controllers/auth/baseAuth.js